import {axiosjs} from '../../static/axios';
import {axiosImage} from '../../static/axios';
//登录
export const userlogin=(data)=>axiosjs({url:'/app-user/login',method:'post',data})
//获取验证码
export const sendVerify=(data)=>axiosjs({url:'/app-user/sendVerify',method:'post',data})
//司机注册
export const addRegister=(data)=>axiosjs({url:'/app-register/addRegister',method:'post',data})
//调度注册
export const addDispatch=(data)=>axiosjs({url:'/app-register/addDispatch',method:'post',data})
//获取地市列表
export const queryCom=(data)=>axiosjs({url:'/ap-area/queryCom',method:'post',data})
//上传图片
export const uploadImage=(data)=>axiosImage({url:'/app-register/uploadImage',method:'post',data})
//添加银行卡
export const addAccount=(data)=>axiosjs({url:'/app-account/addAccount',method:'post',data})
//查询银行卡
export const queryAccount=(data)=>axiosjs({url:'/app-account/queryAccount',method:'post',data})
//删除银行卡
export const delAccount=(data)=>axiosjs({url:'/app-account/delAccount',method:'post',data})
//修改银行卡
export const updateAccount=(data)=>axiosjs({url:'/app-account/updateAccount',method:'post',data})
//更换手机号
export const changePhoneNum=(data)=>axiosjs({url:'/app-user/changePhoneNum',method:'post',data})
//设置密码
export const setPhonePasswd=(data)=>axiosjs({url:'/app-user/setPhonePasswd',method:'post',data})
//忘记密码
export const forgetPasswd=(data)=>axiosjs({url:'/app-user/forgetPasswd',method:'post',data})
//注销
export const logOff=(data)=>axiosjs({url:'/app-user/logOff',method:'post',data})
//用户信息
export const queryPersonalData=(data)=>axiosjs({url:'/app-register/queryPersonalData',method:'post',data})
//黑名单添加
export const addBlackList=(data)=>axiosjs({url:'/app-blacklist/addBlackList',method:'post',data})
//黑名单查询
export const queryBlackList=(data)=>axiosjs({url:'/app-blacklist/queryBlackList',method:'post',data})
//黑名单删除
export const removeBlackList=(data)=>axiosjs({url:'/app-blacklist/removeBlackList',method:'post',data})
//ocr
export const drivingLicense=(data)=>axiosImage({url:'/app-register/ocr/drivingLicense',method:'post',data})
export const addOrder=(data)=>axiosjs({url:'/app-order/addOrder',method:'post',data})//  新增订单
export const pricerules=(data)=>axiosjs({url:'/app-costrules/addOrder',method:'post',data})//  里程计算价格
export const orderList=(data)=>axiosjs({url:'/app-order/orderList',method:'post',data})//  订单列表
export const attachmentorder = (data) => axiosjs({ url:'/app-order/attachmentorder',method:'post',data})//  附近订单列表
export const orderDetail=(data)=>axiosjs({url:'/app-order/orderDetail',method:'post',data})//  订单详情
export const grabOrder=(data)=>axiosjs({url:'/app-order/grabOrder',method:'post',data})//  抢单

export const editOrder=(data)=>axiosjs({url:'/app-order/editOrder',method:'post',data})// 更新订单
export const addEvaluat=(data)=>axiosjs({url:'/app-evaluate/addEvaluat',method:'post',data})// 评价

export const waitOrderList=(data)=>axiosjs({url:'/app-order/waitOrderList',method:'post',data})//  调度者待接单数




// WEBPACK FOOTER //
// ./src/api/attendance.js